export function BrowserMessage() {
    return (
        <div className="BrowserMessage formatted">
            <div className="inner">
                <p>Whoops! The Voting Access Monitor Map is not currently adapted for mobile or a screen size less than 450px. Please visit VAM on your tablet or desktop computer.</p>
            </div>
        </div>
    );
}
